import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { TextInfoBlock } from './TextInfoBlock';
import { TextTitleBlock } from './TextTitleBlock';
import type { textDataType } from './type';

const LeftBlockWrapper = styled.div`
  /* width: 35%; */
  height: 470px;
  background-color: ${theme.colors.neutral[200]};
  border-radius: ${theme.radius.xs};
  padding: ${theme.spacing['8x']};

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const BottomContentWrapper = styled.div``;

type DesktopAndTabletLeftBlockProps = {
  textData: textDataType;
  setIsOpen?: () => void;
};
export const DesktopAndTabletLeftBlock = ({
  textData,
  setIsOpen,
}: DesktopAndTabletLeftBlockProps) => {
  const { isTablet } = useResponsiveVariant();
  return (
    <LeftBlockWrapper>
      <TextTitleBlock textData={textData} />
      <BottomContentWrapper>
        {!isTablet && <TextInfoBlock setIsOpen={setIsOpen} textData={textData.infoBlock} />}
      </BottomContentWrapper>
    </LeftBlockWrapper>
  );
};
